<template lang="pug">
  .basic-contact-info
    .row
      .col
        span {{ $t('姓名') }}:
        span {{ data.user_name }}
      .col
        span {{ $t('职位') }}:
        span {{ data.position }}
      .col
        span {{ $t('手机') }}:
        span {{ data.phone_mobile }}
    .row
      .col
        span {{ $t('性别') }}:
        span {{ data.gender === 1 ? $t('男') : $t('女') }}
      .col
        span {{ $t('登录邮箱') }}:
        span {{ data.mail }}
      .col
        span {{ $t('座机') }}:
        span {{ data.phone_office }}
</template>

<script>
const companyTypeMap = {
  1: 'PrivateCompany',
  2: 'PublishCompany'
}

const companySizeMap = {
  1: 'less than 30',
  2: '30-50',
  3: '50-100',
  4: '100-300',
  5: 'more than 300'
}
export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      companyTypeMap,
      companySizeMap
    }
  }
}
</script>

 <style lang="stylus">
.basic-contact-info
  .row
    display flex
    margin-bottom 10px
    .col
      width 33.3%
      > span:nth-child(1)
        margin-right 10px
        color #262626
      > span:nth-child(2)
        color #5959590
 </style>
